import Date from "common/values/date/date";
import Guid from "common/values/guid/guid";
import { Resource } from "permissions/entities/permission/resources/general";

export default class PermissionTemplate {
  public id: Guid;
  public userId: Guid;
  public resources: Resource[];
  public name: string;
  public description?: string;
  public createdDate?: Date;
  public deletedDate?: Date;

  constructor(
    id: Guid,
    userId: Guid,
    resources: Resource[],
    name: string,
    description?: string,
    createdDate?: Date,
    deletedDate?: Date
  ) {
    this.id = id;
    this.userId = userId;
    this.resources = resources;
    this.name = name;
    this.description = description;
    this.createdDate = createdDate;
    this.deletedDate = deletedDate;
  }

  public get isDeleted(): boolean {
    return !!this.deletedDate;
  }

  public clone(): PermissionTemplate {
    if (!this.id) {
      throw new Error("Cannot clone PermissionTemplate: id is undefined");
    }
    return new PermissionTemplate(
      this.id instanceof Guid ? this.id.clone() : this.id,
      this.userId.clone(),
      this.resources,
      this.name,
      this.description,
      this.createdDate ? this.createdDate.clone() : undefined,
      this.deletedDate ? this.deletedDate.clone() : undefined
    );
  }
}
